module.exports = __webpack_public_path__ + "img/A2_logo.09b05f39.png";